import React from "react";

export default function Nine({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M48.74,58.12V10.71a5.1,5.1,0,0,1,5.1-5.1h48.28V.84H53.84A9.87,9.87,0,0,0,44,10.71V58.12Z" />
      <path d="M198,5.61h48.16a5.1,5.1,0,0,1,5.1,5.1V58.12H256V10.71A9.87,9.87,0,0,0,246.16.84H198Z" />
      <path d="M251.26,154v49a5.1,5.1,0,0,1-5.1,5.1H198v4.78h48.16A9.88,9.88,0,0,0,256,203V154Z" />
      <path d="M102.12,208.14H53.84a5.1,5.1,0,0,1-5.1-5.1V154H44v49a9.88,9.88,0,0,0,9.88,9.88h48.28Z" />
      <path d="M75.81,280.87a2,2,0,0,0-2,2,2,2,0,1,0,2-2Z" />
      <polygon points="68.25 279.59 83.29 279.59 83.29 259.63 68.25 259.48 68.25 279.59" />
      <path d="M245.88,238.21H174.19a2.31,2.31,0,0,1-1.66-.68l-21.07-21.07a2.4,2.4,0,0,0-3.34,0l-21.06,21.07a2.34,2.34,0,0,1-1.67.68H53.7a9.39,9.39,0,0,0-9.39,9.4v42.21a9.39,9.39,0,0,0,9.39,9.4H246a9.34,9.34,0,0,0,9.32-9.4V247.61A9.4,9.4,0,0,0,245.88,238.21ZM85.64,265.76v17.38a3.12,3.12,0,0,1-3.1,3.1H69.16a3.12,3.12,0,0,1-3.1-3.1V255.93a3.12,3.12,0,0,1,3.1-3.1H82.54a3.17,3.17,0,0,1,3.1,3.1Z" />
      <path d="M73.24,257.52h5.14a1.44,1.44,0,0,0,1.44-1.44,1.49,1.49,0,0,0-1.44-1.43H73.32a1.44,1.44,0,1,0-.08,2.87Z" />
      {children}
    </svg>
  );
}
